import createIcon from "./createIcon";

const TrashIcon = createIcon(
  "M13.4166 9.58333V16.2917M9.58325 9.58333V16.2917M5.74992 5.75V17.0583C5.74992 18.1318 5.74992 18.6681 5.95882 19.0781C6.14258 19.4388 6.43558 19.7325 6.79622 19.9163C7.20582 20.125 7.74229 20.125 8.81362 20.125H14.1862C15.2575 20.125 15.7932 20.125 16.2028 19.9163C16.5635 19.7325 16.8575 19.4388 17.0412 19.0781C17.2499 18.6685 17.2499 18.1326 17.2499 17.0613V5.75M5.74992 5.75H7.66659M5.74992 5.75H3.83325M7.66659 5.75H15.3333M7.66659 5.75C7.66659 4.85695 7.66659 4.41064 7.81248 4.05841C8.00701 3.58877 8.37989 3.21543 8.84953 3.0209C9.20176 2.875 9.64853 2.875 10.5416 2.875H12.4583C13.3513 2.875 13.7978 2.875 14.1501 3.0209C14.6197 3.21543 14.9927 3.58877 15.1873 4.05841C15.3332 4.41064 15.3333 4.85695 15.3333 5.75M15.3333 5.75H17.2499M17.2499 5.75H19.1666",
  "#CB1F31",
  "1.2",
  "0 0 23 23"
);

export default TrashIcon;
